<template>
    <!-- vocation.svg -->
    <svg class="nav-logo" id="VOCATION_FULL_LOGO" data-name="VOCATION FULL LOGO" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="60.313" viewBox="0 0 593.938 116.313">
  <defs>
   
    <linearGradient id="logo-gradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
                gradientTransform="rotate(140 .5 .5)">
    <stop offset="0%" stop-color="#ffffff" />
    <stop offset="51%" stop-color="#b121d1" />
    <stop offset="69%" stop-color="#ab20c9" />
    <stop offset="91%" stop-color="#ab20c9" />
</linearGradient>
    <filter id="filter" x="885.531" y="580.969" width="74.157" height="81.5" filterUnits="userSpaceOnUse">
      <feFlood result="flood"/>
      <feComposite result="composite" operator="in" in2="SourceGraphic"/>
      <feBlend result="blend" in2="SourceGraphic"/>
    </filter>
    <filter id="filter-2" x="572.844" y="547.406" width="315.812" height="115.813" filterUnits="userSpaceOnUse">
      <feFlood result="flood"/>
      <feComposite result="composite" operator="in" in2="SourceGraphic"/>
      <feBlend result="blend" in2="SourceGraphic"/>
    </filter>
    <filter id="filter-3" x="491.156" y="578.625" width="84.75" height="85.094" filterUnits="userSpaceOnUse">
      <feImage preserveAspectRatio="none" x="491.156" y="578.625" width="84.75" height="85.094" result="image" xlink:href="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iODQuNzUiIGhlaWdodD0iODUuMDk0IiB2aWV3Qm94PSIwIDAgODQuNzUgODUuMDk0Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiB1cmwoI2xpbmVhci1ncmFkaWVudCk7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeTE9Ijc2Ljg2MiIgeDI9Ijg0Ljc1IiB5Mj0iOC4yMzIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agb2Zmc2V0PSItMC4yNSIgc3RvcC1jb2xvcj0iIzYxMWU3MCIvPgogICAgICA8c3RvcCBvZmZzZXQ9Ii0wLjIxOSIgc3RvcC1jb2xvcj0iIzYxMWU3MCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjAuNDIiIHN0b3AtY29sb3I9IiNiMTIxZDEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIwLjk1NSIgc3RvcC1jb2xvcj0iI2U0YWFmYSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEuMjUiIHN0b3AtY29sb3I9IiNlNGFhZmEiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9Ijg0Ljc1IiBoZWlnaHQ9Ijg1LjA5NCIvPgo8L3N2Zz4K"/>
      <feComposite result="composite" operator="in" in2="SourceGraphic"/>
      <feBlend result="blend" in2="SourceGraphic"/>
    </filter>
    <filter id="filter-4" x="400" y="557.75" width="105.125" height="105.531" filterUnits="userSpaceOnUse">
      <feFlood result="flood"/>
      <feComposite result="composite" operator="in" in2="SourceGraphic"/>
      <feBlend result="blend" in2="SourceGraphic"/>
    </filter>
    <filter id="filter-5" x="968.688" y="576.281" width="25.25" height="13.25" filterUnits="userSpaceOnUse">
      <feFlood result="flood"/>
      <feComposite result="composite" operator="in" in2="SourceGraphic"/>
      <feBlend result="blend" in2="SourceGraphic"/>
    </filter>
  </defs>
  <g id="VOCATION">
    <path id="n" class="cls-1" d="M908.985,602.027a22.21,22.21,0,0,1,15.282-5.809q18.457,0,18.459,22.18v44.058h16.946V613.268q0-15.692-8.4-23.991t-22.015-8.3a30.542,30.542,0,0,0-26.782,15.843V582.185H885.532v80.271h16.946V619Q902.478,607.837,908.985,602.027Z" transform="translate(-400 -547.406)"/>
    <path id="catio" class="cls-2" d="M647.816,648.434l-10-10.873q-10,10.272-21.281,10.269a25.873,25.873,0,0,1-19.008-7.7,25.539,25.539,0,0,1-7.725-18.8q0-11.1,7.8-18.121a26.606,26.606,0,0,1,18.4-7.022q10.6,0,21.054,9.061l10-12.232a41.894,41.894,0,0,0-30.747-12.533q-18.176,0-30.823,11.552t-12.647,29.974q0,18.425,12.117,29.823a40.747,40.747,0,0,0,28.93,11.4q19.233,0,33.928-14.8h0Zm70.128-38.2q0-15.4-9.012-22.575t-23.25-7.173a52.272,52.272,0,0,0-33.322,11.627l7.573,10.571q12.115-8.155,23.325-8.155,17.871,0,17.873,16.007v3.02H679.169q-15,0-23.78,5.889T646.6,637.184q0,11.856,8.255,18.951t20.826,7.1q16.814,0,26.809-11.929v10.721h15.45V610.23Zm-23.023,34.127a23,23,0,0,1-14.162,4.53q-8.1,0-12.647-3.1a10.194,10.194,0,0,1-4.544-8.985q0-11.474,18.327-11.476H700.98v6.795A14.485,14.485,0,0,1,694.921,644.357Zm75.732-49.077V581.69H749.448V556.472H732.484V581.69H722.336v13.59h10.148V635.6q0,12.686,7.649,20.159a25.469,25.469,0,0,0,18.479,7.475q10.827,0,19.766-8L771.411,643.3q-5,5.288-10.451,5.285t-8.482-3.4q-3.031-3.4-3.03-9.136V595.28h21.205Zm26.052-13.59H779.741v80.334h16.964V581.69Zm-8.33-12.835a10.845,10.845,0,1,0-7.573-3.171A10.358,10.358,0,0,0,788.375,568.855Zm32.413,53q0-11.626,7.195-18.951t18.251-7.324q11.055,0,18.252,7.324t7.194,18.951q0,11.63-7.194,18.951t-18.252,7.324q-11.058,0-18.251-7.324T820.788,621.857Zm67.856,0a39.765,39.765,0,0,0-12.117-29.37q-12.12-12-30.293-12t-30.293,12a41.653,41.653,0,0,0,0,58.74q12.117,12.006,30.293,12t30.293-12A39.76,39.76,0,0,0,888.644,621.857Z" transform="translate(-400 -547.406)"/>
    <path id="O" class="cls-3" d="M512.246,584.344A43.868,43.868,0,0,0,500.362,594.5a23.569,23.569,0,0,1,6.061-2.451,23.033,23.033,0,0,1,6.473-.7,19.884,19.884,0,0,1,6.12,1.167,16.818,16.818,0,0,1,5,2.8,29.866,29.866,0,0,1,9.415-1.4,26.174,26.174,0,0,1,19.066,7.92,28.515,28.515,0,0,1-.007,39.131,25.307,25.307,0,0,1-18.734,7.92,26.515,26.515,0,0,1-17.317-6.186,25.048,25.048,0,0,1-9.661-19.491q-0.237-5.716,1.774-9.22a11.5,11.5,0,0,1,4.968-4.9,9.483,9.483,0,0,1,6.212-.7,9.7,9.7,0,0,1,5.5,3.385,13.844,13.844,0,0,0-.059-8.111,10.979,10.979,0,0,0-4.056-5.427,15.992,15.992,0,0,0-6.642-2.626,20.13,20.13,0,0,0-14.87,3.326,15.884,15.884,0,0,0-5.29,6.069,19.117,19.117,0,0,0-1.528,3.793,35.454,35.454,0,0,0-.941,4.26q-0.353,2.219-.529,4.26t-0.176,3.793A41.547,41.547,0,0,0,503.253,651.1q12.107,12.6,30.564,12.605a40.824,40.824,0,0,0,29.859-12.255Q575.9,639.315,575.9,621.458a41.1,41.1,0,0,0-12.471-30.345,40.367,40.367,0,0,0-29.769-12.488,42.458,42.458,0,0,0-21.415,5.719h0Z" transform="translate(-400 -547.406)"/>
    <path id="V" class="cls-4" d="M505.119,557.74H485.125l-32.564,78.824L420,557.74H400l42.562,105.551h19.993Z" transform="translate(-400 -547.406)"/>
    <path id="TM"  class="cls-5" d="M974.813,589.543v-11.7H979.2v-1.564H968.7v1.564h4.364v11.7h1.753Zm8.186,0V578.254l3.831,11.289h1.582l3.849-11.1v11.1h1.689v-13.26h-2.358l-3.171,9.226q-0.48,1.4-.705,2.126-0.2-.651-0.633-1.963l-3.135-9.389h-2.639v13.26H983Z" transform="translate(-400 -547.406)"/>
  </g>
</svg>


</template>
<script>
export default {
   
}
</script>
<style scoped>

.nav-logo, .cls-1{
    fill: var(--logo);
}
     /* .cls-1, .cls-2, .cls-4, .cls-5, .cls-6 {
        stroke: currentColor;
      } */

    

      /* .cls-1 {
        fill: currentColor;
      }

      .cls-2 {
        fill: currentColor;
      } */

      .cls-3 {
        fill: url(#logo-gradient);
      }

      /* .cls-4 {
        fill: currentColor;
      }

      .cls-5 {
        fill: currentColor;
      }

      .cls-6 {
        fill: currentColor;
      } */
</style>